<template>
  <v-container class="px-0 px-md-6">
    <v-row justify="center">
      <v-col sm="12" md="10" lg="8" xl="8`">
        <slot />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>